$('#current_domain').on('change', function() {
    const selectedValue = $(this).val();
    const csrftoken = $("[name=csrfmiddlewaretoken]").val();
    if (selectedValue == "") {
        applyCurrentDomain();
    }
    $.ajax({
        url: 'api/domain/set',
        method: 'POST',
        headers: {
            'X-CSRFToken': csrftoken
        },
        data: { domain_id: selectedValue },
        success: function(response) {
            applyCurrentDomain(selectedValue);
            return;
        },
        error: function(xhr, status, error) {
            console.error('API error:', error);
        }
    });
});

function applyCurrentDomain(domain_id=null){
    console.log("Applying current domain:", domain_id);
    const hasDomain = domain_id && domain_id !== "" && domain_id !== "null";
    $('.control').each(function() {
        const detail = $(this);
        const type = detail.data('type');

        if (hasDomain) {
            detail.removeClass('opacity-60 pointer-events-none cursor-not-allowed');
            detail.find('a').each(function() {
                const action = $(this).data('action');
                if (action) {
                    $(this).attr('href', `/${type}/${action}?domain=${domain_id}`);
                }
            });
        } else {
            detail.addClass('opacity-60 pointer-events-none cursor-not-allowed');
            detail.find('a').each(function() {
                $(this).attr('href', '#');
            });
        }

    })
}